import { render, staticRenderFns } from "./under-construction.component.vue?vue&type=template&id=4634ad3a&scoped=true&"
import script from "./under-construction.component.vue?vue&type=script&lang=ts&"
export * from "./under-construction.component.vue?vue&type=script&lang=ts&"
import style0 from "./under-construction.component.vue?vue&type=style&index=0&id=4634ad3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634ad3a",
  null
  
)

export default component.exports